'use client'

import { MouseEvent, PropsWithChildren } from 'react'
import styles from './Button.module.scss'

type Props = {
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void
  disabled?: boolean
  type?: 'button' | 'submit' | 'reset'
  variety?: 'primary' | 'secondary' | 'tertiary' | 'tertiary-ghost'
  scrollToId?: string
  fullWidth?: boolean
}

const Button = ({
  onClick = undefined,
  disabled = false,
  type = 'button',
  variety = 'primary',
  scrollToId,
  fullWidth = false,
  children,
}: PropsWithChildren<Props>) => {
  const handleOnClick = (e: MouseEvent<HTMLButtonElement>) => {
    if (onClick) onClick(e)
    if (scrollToId) {
      const element = document.getElementById(scrollToId)
      element?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  return (
    <button type={type} className={`${styles.button} ${styles[variety]} ${fullWidth ? styles.fullWidth : ''}`} disabled={disabled} onClick={handleOnClick}>
      {children}
    </button>
  )
}

export default Button
